import {
  darkErrorToast,
  lightErrorToast,
  lightSuccessToast,
} from "../../Components/customToast";
import requestMethods from "../../helpers/request";
import i18n from "../../i18n";
import { getStatus } from "../../services/serviceActions";
import { getTripBookingAreasSuccess, saveTripDetails } from "./homeSlice";

export const getAllAssignedTasks = () => async (dispatch) => {
  try {
    const response = await requestMethods.GET({
      endpoint: "v1/shifter/mobile/get-all-assigned-tasks",
    });
    dispatch(saveTripDetails(response));
  } catch (error) {
    lightErrorToast(error.message);
  }
};

export const rejectTrip =
  (tripId, reason = "", toggleUpdating) =>
  async (dispatch) => {
    try {
      const res = await requestMethods.PUT({
        endpoint: `v1/shifter/clubbed/trip/mobile/${tripId}/trip_rejection`,
        body: {
          rejection_reason: reason,
        },
      });

      if (res.status) {
        toggleUpdating();
        lightSuccessToast(i18n.t("Trip Rejected Successfully"));
        dispatch(getStatus());
        dispatch(getAllAssignedTasks());
      }
    } catch (error) {
      toggleUpdating();
      lightErrorToast(error.message);
    }
  };

export const requestBreak = (timeRequestedForBreak = null, toggleBreak) => {
  return async (dispatch) => {
    try {
      const res = await requestMethods.POST({
        endpoint: "v1/shifter/mobile/request-break",
        body: {
          ...(timeRequestedForBreak && {
            time_requested_for_break: timeRequestedForBreak,
          }),
        },
      });
      if (res.status) {
        lightSuccessToast(res.message);
        if (toggleBreak) toggleBreak();
        dispatch(getStatus());
      }
    } catch (error) {
      lightErrorToast(error.message);
      if (toggleBreak) toggleBreak();
      dispatch(getStatus());
    }
  };
};

export const endBreak =
  (toggleBreak, endSuccess, closeModal) => async (dispatch) => {
    try {
      const res = await requestMethods.POST({
        endpoint: "v1/shifter/mobile/break/stop",
      });
      if (res.status) {
        if (toggleBreak) toggleBreak();
        if (endSuccess) endSuccess();
        if (closeModal) closeModal();
        dispatch(getStatus());
      }
    } catch (error) {
      if (closeModal) closeModal();
      lightErrorToast(error.message);
    }
  };

export const getTripBookingAreas = (loader) => async (dispatch) => {
  try {
    const res = await requestMethods.GET({
      endpoint: "v1/shifter/clubbed/trip/mobile/get-shifter-trip-booking-areas",
    });
    if (res.status) {
      dispatch(getTripBookingAreasSuccess(res));
      if (loader) loader();
    }
  } catch (error) {
    lightErrorToast(error.message);
    if (loader) loader();
  }
};

export const bookTrip = (body, successBook, stopLoader) => async (dispatch) => {
  try {
    const res = await requestMethods.POST({
      endpoint: "v1/shifter/mobile/trip-book",
      body,
    });

    if (res.status) {
      if (stopLoader) stopLoader();
      if (successBook) successBook();
      lightSuccessToast(i18n.t("Trip booked successfully"));
      dispatch(getAllAssignedTasks());
      dispatch(getStatus());
    }
  } catch (error) {
    if (stopLoader) stopLoader();
    darkErrorToast(error.message);
  }
};

export const updateShifterBookedTrip = (tripId, loader) => async (dispatch) => {
  try {
    const res = await requestMethods.PUT({
      endpoint: `v1/shifter/clubbed/trip/mobile/update-shifter-booked-trip-status/${tripId}/complete`,
    });

    if (res.status) {
      lightSuccessToast(i18n.t("Status successfully updated"));
      if (loader) loader();
      dispatch(getAllAssignedTasks());
      dispatch(getStatus());
    }
  } catch (error) {
    if (loader) loader();
    darkErrorToast(error.message);
  }
};
